import React, { FC } from 'react'
import { motion } from 'framer-motion'

interface IMorphingRotateIconProps {
  className?: string
  color?: string
  isHovered?: boolean
  direction?: 'ccw' | 'cw'
}

export const MorphingRotateIcon: FC<IMorphingRotateIconProps> = ({
  className = '',
  color = 'currentColor',
  isHovered,
  direction = 'ccw',
}) => {
  const transition = { duration: 0.5, ease: [0.16, 1, 0.3, 1] }

  // Counter-clockwise svg rotation on hover
  const svgVariants = {
    initial: {
      rotate: 0,
      transition,
    },
    hover: {
      rotate: -45,
      transition,
    },
  }

  // Shaft of arrow bends into circular counter-clockwise arc
  const arcVariants = {
    initial: {
      d: 'M 19 12 C 17.44 12, 15.89 12, 14.33 12 C 12.78 12, 11.22 12, 9.67 12 C 8.11 12, 6.56 12, 5 12',
      transition,
    },
    hover: {
      d: 'M 12 19.5 C 16.14 19.5, 19.5 16.14, 19.5 12 C 19.5 7.86, 16.14 4.5, 12 4.5 C 9.2 4.5, 8.5 5.7, 6.7 7.5',
      transition,
    },
  }

  // Top wing of arrow folds into top arrowhead of rotate icon
  const wing1Variants = {
    initial: {
      d: 'M 12 5 L 5 12',
      transition,
    },
    hover: {
      d: 'M 12 7.5 L 6.7 7.5',
      transition,
    },
  }

  // Bottom wing of arrow folds into side arrowhead of rotate icon
  const wing2Variants = {
    initial: {
      d: 'M 12 19 L 5 12',
      transition,
    },
    hover: {
      d: 'M 7 2.5 L 6.7 7.5',
      transition,
    },
  }

  const animationState = isHovered !== undefined ? (isHovered ? 'hover' : 'initial') : undefined

  return (
    <span
      className="inline-flex items-center justify-center w-6 h-6 shrink-0"
      style={{ transform: direction === 'cw' ? 'scaleX(-1)' : undefined }}
    >
      <motion.svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        initial="initial"
        animate={animationState}
        whileHover={isHovered === undefined ? 'hover' : undefined}
        variants={svgVariants}
        className={`w-6 h-6 overflow-visible ${className}`}
        style={{ transformOrigin: '50% 50%' }}
      >
        <motion.path
          variants={arcVariants}
          stroke={color || 'currentColor'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <motion.path
          variants={wing1Variants}
          stroke={color || 'currentColor'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <motion.path
          variants={wing2Variants}
          stroke={color || 'currentColor'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </motion.svg>
    </span>
  )
}

export default MorphingRotateIcon

